import SliderRange from "designSystem/components/slider/SliderRange";
import React, { useState } from "react";

export default () => {
	const [value, setValue] = useState<[number, number]>([20, 30]);

	const onChangeValue = (value: [number, number], activeThumb: number) => {
		setValue(value);
	};

	return (
		<SliderRange
			disableSwap
			includeTextFields
			max={100}
			min={0}
			onChange={onChangeValue}
			spacingAround={2}
			step={1}
			value={value}
		/>
	);
};